import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getDashboardData = () => async (dispatch) => {
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/dashboard', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'DASHBOARD_SUCCESS', payload: data })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getProfile = () => async (dispatch) => {
    dispatch({ type: 'PROFILE_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/profile', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'PROFILE_SUCCESS', payload: data })
        }
    } catch (error) {
        dispatch({ type: 'PROFILE_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const updateProfile = (profileData) => async (dispatch) => {
    dispatch({ type: 'PROFILE_UPDATING' })
    try {
        const { data, status } = await Axios.put('/api/teacher/profile', profileData, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            if (data.token) {
                localStorage.setItem('jwt', data.token)
            }
            dispatch({ type: 'PROFILE_UPDATE_SUCCESS', payload: data.message })
            dispatch({ type: 'PROFILE_TOKEN_UPDATE', payload: data.token })
        }
    } catch (error) {
        dispatch({ type: 'PROFILE_UPDATE_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const changePassword = (currentPassword, newPassword) => async (dispatch) => {
    dispatch({ type: 'PROFILE_UPDATING' })
    try {
        const { data, status } = await Axios.put('/api/profile/change-password', {
            password: currentPassword,
            newPassword
        }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            if (data.token) {
                localStorage.setItem('jwt', data.token)
            }
            dispatch({ type: 'PROFILE_UPDATE_SUCCESS', payload: data.message })
            dispatch({ type: 'PROFILE_TOKEN_UPDATE', payload: data.token })
        }
    } catch (error) {
        dispatch({ type: 'PROFILE_UPDATE_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const uploadAvatar = (imageUrl) => async (dispatch) => {
    dispatch({ type: 'AVATAR_UPLOADING' })
    try {
        const { data, status } = await Axios.put('/api/profile/avatar', { avatar: imageUrl }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'AVATAR_SUCCESS', payload: data.avatar })
        }
    } catch (error) {
        dispatch({ type: 'AVATAR_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getUnreadCount = () => async (dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/teacher/unread-count', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'UNREAD_COUNT_SUCCESS', payload: data.count })
        }
    } catch (error) {}
}
